import React from 'react';
import {Form, Button, Modal } from "antd";
import 'antd/lib/modal/style/css';
import {reduxForm} from "redux-form";
import language from "../../languages/language";


class ConfirmModal extends React.Component {

  render() {
    return (
        <Modal
            visible={this.props.modalType !== null} width={400} {...this.props.modalProps} title={this.props.modalProps.title}>
          <Form onFinish={this.props.handleSubmit(this.props.onSubmit)}>
			<div style={{'textAlign': 'center'}}>
                {this.props.comment}
			<br/>
			<br/>
            <Button htmlType={'submit'} type={'primary'}>{language[this.props.language].yesLabel}</Button>
			<Button type={'primary'} onClick={this.props.onCancel}>{language[this.props.language].noLabel}</Button>
			</div>
          </Form>
        </Modal>
    )
  }


}

export default reduxForm({form: 'confirm_modal_form'})(ConfirmModal);
